var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Header',{attrs:{"day":_vm.day}}),(_vm.schedule)?_c('router-view',{attrs:{"schedule":_vm.schedule}}):(_vm.loading)?_c('Loading'):_c('Error'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }